import { render, staticRenderFns } from "./StarsListItem.vue?vue&type=template&id=ac870b7a&scoped=true&"
import script from "./StarsListItem.vue?vue&type=script&lang=js&"
export * from "./StarsListItem.vue?vue&type=script&lang=js&"
import style0 from "./StarsListItem.vue?vue&type=style&index=0&id=ac870b7a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac870b7a",
  null
  
)

component.options.__file = "StarsListItem.vue"
export default component.exports